<template>
    <v-card :loading="loading">
        <v-card-title>
            {{title}}
            <v-spacer></v-spacer>
            <!-- Reload Reserve -->
            <v-tooltip
                top
                color="primary"
                content-class="caption iransans font-weight-medium px-3"
        >
            <template #activator="{on}">
                <v-btn
                        icon
                        v-on="on"
                        small
                        @click="syncReport"
                >
                    <v-icon :class="{ 'mdi-spin' : loading }">mdi-cached</v-icon>
                </v-btn>
            </template>

            <span>{{$t('reload')}}</span>
        </v-tooltip>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <v-btn-toggle
                            mandatory
                            tile
                            x-small
                            dense
                            v-model="timeReport"
                    >
                        <v-btn value="today">
                            امروز
                        </v-btn>
                        <v-btn value="yesterday">
                            دیروز
                        </v-btn>
                        <v-btn value="month">
                            ماه جاری
                        </v-btn>
                        <v-btn value="customDate" @click="show=true">
                            <span v-if="customDate">
                            {{ getJalaliDate(customDate[0] * 1000, 'jYYYY/jMM/jDD HH:mm:ss ') }}
                                تا
                            {{ getJalaliDate(customDate[1] * 1000, 'jYYYY/jMM/jDD HH:mm:ss ') }}

                            </span>
                            <span v-else>انتخاب تاریخ</span>
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
            <Highcharts :options="chartOptions"/>
        </v-card-text>
       
        <date-picker
                :show="show"
                @close="show=false"
                v-model="customDate"
                :element=elementDatePicker
                format="X"
                range
                display-format="jYYYY/jMM/jDD HH:mm:ss"
                type="date"
        />
    </v-card>
</template>

<script>
    import config from '@/config';
    import Service from '../services/FaxesService';
    import Moment from 'moment-jalaali';

    import { Chart } from 'highcharts-vue';

    export default {
        components: {
            Highcharts: Chart
        },
        props: {
            id: {
                type: String,
                default : 'fax-overview-' + (new Date).getTime()
            },
            type: {
                type: String
            },
            extraFilters: {
                type: Object,
                default : ()=>{
                    return {};
                }
            },
            title: {
                type: String
            },
        },
        computed : {
            elementDatePicker(){
                return `#${this.id}`;
            },
            filters(){
                let from;
                let to;
                switch (this.timeReport){
                    case 'today':
                        from = Moment().startOf('day').unix();
                        to = Moment().endOf('day').unix();
                    break;
                    case 'yesterday':
                        from = Moment().add(-1, 'day').startOf('day').unix();
                        to = Moment().add(-1, 'day').endOf('day').unix();
                        break;
                    case 'month':
                        from = Moment().startOf('jMonth').unix();
                        to = Moment().endOf('day').unix();
                        break;
                    case 'customDate':
                        from = this.customDate[0];
                        to = this.customDate[1];
                        break;
                }
                return Object.assign({
                    type : { column_name : 'type', operand : 'IsEqualTo', value : this.type},
                    created_at : { column_name : 'created_at', operand : 'Between', value : [from,to]}
                }, this.extraFilters)

            }
        },
        data() {
            return {
                show : false,
                timeReport : 'today',
                customDate : undefined,
                chartOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie'
                    },
                    title: {
                        text: null,
                        useHTML: true,
                        style: {
                            fontFamily: 'IRANSans',
                            fontWeight: 700
                        }
                    },
                    tooltip: {
                        useHTML: true,
                        style: {
                            fontFamily: 'IRANSans'
                        },
                        formatter() {
                            return `
                                <div class="text-center font-weight-bold mb-1"> ${this.point.name} %${this.point.percentage.toFixed(2)}</div>
                                <div class="text-right">
                                    ${this.point.send_request}<br>
                                    ${this.point.number_of_pages}<br>
                                    ${this.point.attempts}
                                </div>

                            `;
                        }
                    },
                    plotOptions: {
                        pie: {
                            dataLabels: {
                                enabled: false,
                            },
                            allowPointSelect: true,
                            cursor: 'pointer',
                            showInLegend: true
                        }
                    },
                    legend: {
                        useHTML: true,
                        y: 15,
                        itemStyle: {
                            fontFamily: 'IRANSans',
                            top: 0
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    series: []
                },
                loading: false,

                reservationStates: config.reservationStates,
                reports: [],
                locations: {}
            }
        },
        async mounted() {
            await this.syncReport();
        },
        methods: {
            async syncReport() {
                this.loading = true;
                try {
                    let {
                        data
                    } = await Service.getOverviewReport('yearly', this.filters);
                    this.reports = data.value.faxes_overview;
                } finally {
                    this.loading = false;
                }
                this.updateChart();
            },
            updateChart(){
                let chart = {
                    name: this.$t('fax'),
                    colorByPoint: true,
                    data: []
                };
                this.reports.map((report) => {
                    chart.data.push({
                        name: this.$t(`fax_status.${report.status}`),
                        color : this.$vuetify.theme.themes.light[`fax_${report.status}`],
                        y : report.total,
                        send_request : `${this.$t('send_fax_form_title')} ${report.total}`,
                        number_of_pages : `${this.$t('number_of_pages')} ${report.number_of_pages}`,
                        attempts : `${this.$t('attempts')} ${report.attempts}`,
                    });
                });
                this.chartOptions.series = [chart];
            }
        },
        watch : {
            customDate(value){
                if(value){
                    this.syncReport();
                }
            },
            timeReport(value){
                if(value !== 'customDate'){
                    this.customDate = null;
                    this.syncReport();
                }

            }
        }
    }
</script>